var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSizeclip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill-opacity:0.15;}\r\n\t.st2{fill:#222020;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M19,18.3V5.1H5.7v6.6h5.7c0.5,0,0.9,0.4,0.9,0.9v5.7H19z M3.8,4.1c0-0.5,0.4-0.9,0.9-0.9h15.1 c0.5,0,0.9,0.4,0.9,0.9v15.1c0,0.5-0.4,0.9-0.9,0.9H4.8c-0.5,0-0.9-0.4-0.9-0.9V4.1z M5.7,13.6v4.7h4.7v-4.7H5.7z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSizeclip);
export default __webpack_public_path__ + "static/media/sizeclip.035b379f0de81d65fb0077a4c6ed8291.svg";
export { ForwardRef as ReactComponent };